/**
 * Initializes a MutationObserver on the product listing section of a collection page,
 * specifically targeting elements with the class `.collection__products`.
 *
 * This script monitors for changes (e.g. products loading or updating) and, for each
 * product item (`.product-item`), checks if Yotpo review data is present.
 *
 * If Yotpo review data exists and hasn't already been processed (based on a missing "active" class),
 * it extracts the total number of reviews from the tooltip/title of the rating summary,
 * inserts the count into the `.yotpo-sr-bottom-line-score` element,
 * and adds an "active" class to prevent duplicate processing.
 *
 * The observer is initialized after the `window` load event to ensure all content is available.
 *
 * Usage:
 * - Automatically runs on page load
 * - Dynamically updates review counts as new products are added to the DOM
 */

window.neptune.plp.reviews = function () {
   const targetNode = document.querySelector(".collection__products");
   const config = { attributes: true, childList: true, subtree: true };
   const callback = (mutationList, observer) => {
      document.querySelectorAll('.product-item').forEach(e => {
         var reviewData = e.querySelector('.yotpo-sr-bottom-line-summary span[role="img"]');
         var reviewSummary = e.querySelector('.yotpo-sr-bottom-line-score');

         if (reviewData != null) {
            var isActive = Array.from(reviewSummary.classList).filter(e => e.indexOf("active") != -1)
            if (isActive == false) {
               var count = reviewData.title.toLowerCase().split('total')[1].split(' ')[1];
               reviewSummary.innerHTML = count;
               reviewSummary.classList.add("active");
            }
         }
      });
   };

   const observer = new MutationObserver(callback);
   observer.observe(targetNode, config);
}

window.addEventListener('load', function () {
   window.neptune.plp.reviews()
})